<template>
    <client-page class="wrap--sub">
        <!-- 서브비주얼 -->
        <sub-visual :visual="'전자제조지원센터'"></sub-visual>
        <div class="tab-list--primary-wrap">
            <ul class="tab-list tab-list--primary">
                <li><router-link to="/about" class="button">센터개요</router-link></li>
                <li><router-link to="/about/equipments" class="button">장비소개</router-link></li>
                <li class="on"><router-link to="/about/location" class="button">오시는 길</router-link></li>
                <!-- <li><router-link to="/about/business" class="button">사업개요</router-link></li> -->
            </ul>
        </div>

        <section class="section">
            <v-container>
                <tit-primary
                sc="오시는길을 안내해드립니다"
                tit="한국전자정보통신산업진흥회에 오신 걸 환영합니다.">
                </tit-primary>

                <div class="rounded mb-50 mb-lg-80">
                    <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3163.9226635860596!2d126.95866385116791!3d37.53332027970516!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x357ca2044a851009%3A0x8c6a3c15fd3de146!2z7ISc7Jq47Yq567OE7IucIOyaqeyCsOq1rCDtlZzqsJXroZwz6rCAIDE2LTIw!5e0!3m2!1sko!2skr!4v1633684512789!5m2!1sko!2skr" width="100%" height="520" style="border:0;" allowfullscreen="" loading="lazy" class="d-block"></iframe>
                </div>

                <ul class="border-top border-2 border-color-black page-text pt-lg-20 page-text">
                    <li class="py-12 py-md-30 py-lg-34 border-bottom">
                        <p class="font-weight-bold mb-4 mb-lg-10">
                            한국전자정보통신산업진흥회
                        </p>
                        <p class="color-grey">
                            서울시 용산구 청파로77 원효전자상가6동 3층 ‘용산전자상상가’
                        </p>
                    </li>
                    <li class="py-12 py-md-30 py-lg-34 border-bottom">
                        <p class="font-weight-bold mb-4 mb-lg-10">
                            지하철 노선 안내
                        </p>
                        <div>
                            <div class="d-flex align-center mb-6 mb-lg-14">
                                <div class="rounded-tit d-flex align-center justify-center text-center line-height-1 mr-8 mr-lg-16" style="background-color: #2d53a8">
                                    <p class="page-text--sm color-white">1호선</p>
                                </div>
                                <p class="color-grey">
                                    <strong class="font-weight-bold">용산역 1호선 3번 출구</strong>와 직접 연결된 통로로 진입, 도보 8분
                                </p>
                            </div>
                            <div class="d-flex align-center mb-6 mb-lg-14">
                                <div class="rounded-tit d-flex align-center justify-center text-center line-height-1 mr-8 mr-lg-16" style="background-color: #3c66ae">
                                    <p class="page-text--sm color-white">4호선</p>
                                </div>
                                <p class="color-grey">
                                    <strong class="font-weight-bold">신용산역 4호선 4번 출구</strong>에서 도보 약 14분 거리
                                </p>
                            </div>
                            <div class="d-flex align-center">
                                <div class="rounded-tit d-flex align-center justify-center text-center line-height-1 mr-8 mr-lg-16" style="background-color: #96572c">
                                    <p class="page-text--sm color-white">6호선</p>
                                </div>
                                <p class="color-grey">
                                    <strong class="font-weight-bold">효창공원역 6호선 3번 출구</strong>에서 도보 약 16분 거리
                                </p>
                            </div>
                        </div>
                    </li>
                    <li class="py-12 py-md-30 py-lg-34 border-bottom">
                        <p class="font-weight-bold mb-4 mb-lg-10">
                            버스 노선 안내
                        </p>
                        <div class="color-grey">
                            <p class="line-txt mb-2 mb-lg-4">
                                - 용산전자상가 10동 정류장 하차 - (간선) <span style="color: #005b9f">■</span>505, (지선) <span style="color: #0f9f00">■</span>5012
                            </p>
                            <p class="line-txt mb-2 mb-lg-4">
                                - 용산전자상가 12동 정류장 하차 - (간선) <span style="color: #005b9f">■</span>505, (지선) <span style="color: #0f9f00">■</span>5012
                            </p>
                            <p class="line-txt">
                                - 신용산, 지하차도 정류장 하차 - (간선) <span style="color: #005b9f">■</span>404, (지선) <span style="color: #0f9f00">■</span>0017, <span style="color: #0f9f00">■</span>5012
                            </p>
                        </div>
                    </li>
                    <li class="pt-12 pt-md-30 pt-lg-34">
                        <p class="font-weight-bold mb-4 mb-lg-10">
                            주차장 안내
                        </p>
                        <div class="color-grey">
                            <p class="line-txt mb-2 mb-lg-4">
                                - 원효전자상가 주차장 - 서울시 용산구 원효로 3가 51-30
                            </p>
                            <p class="line-txt">
                                - 공영주차장 - 서울시 용산구 신계동 42-1
                            </p>
                        </div>
                    </li>
                </ul>
            </v-container>
        </section>

    </client-page>
</template>

<script>
import ClientPage from "@/pages/client/templates/ClientPage.vue";
import SubVisual from "@/components/client/sub/sub-visual.vue";
import TitPrimary from "@/components/client/dumb/tit-primary.vue";
export default {
    components: {
        ClientPage,
        SubVisual,
        TitPrimary,
    },
};
</script>

<style scoped>
.rounded-tit{
    min-width: 56px;
    width: 56px;
    height: 24px;
    border-radius: 13px;
}

@media (min-width:576px){
}
@media (min-width:768px){
}
@media (min-width:1024px){
    .rounded-tit{
        min-width: 70px;
        width: 70px;
        height: 26px;
        border-radius: 13px;
    }
}
@media (min-width:1200px){
}

</style>